var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{staticClass:"l-ss-c-offer-compare-icon",class:{
        'l-ss-c-offer-compare-icon-active': _vm.isCompareOffer
    },style:(_vm.style),domProps:{"innerHTML":_vm._s(_vm.currentIcon)},on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.clickOnAddToCompareHandler($event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }